import {
  DWELLING_STATUSES,
  STATUS_SWATCH,
  unitStatus,
  type Unit,
} from '@alrimal/contracts';
import { useLocale } from '../LocaleContext.tsx';
import type { MessageKey } from '../i18n.ts';

/**
 * Availability key — permanently on screen, never hover-only (§7).
 *
 * Any colour that carries meaning ships with a key visible on the same screen.
 * The count beside each status is not decoration either: it is the fastest
 * honest answer to "is anything left?".
 */
export function Legend({ units }: { units: readonly Unit[] }) {
  const { t } = useLocale();

  const counts = new Map<string, number>();
  for (const unit of units) {
    const status = unitStatus(unit);
    counts.set(status, (counts.get(status) ?? 0) + 1);
  }

  return (
    <aside className="legend" aria-label={t('legend.title')}>
      <p className="legend__title">{t('legend.title')}</p>
      <ul className="legend__items">
        {DWELLING_STATUSES.map((status) => (
          <li className="legend__item" key={status}>
            <span
              className="legend__swatch"
              style={{ background: STATUS_SWATCH[status] }}
              aria-hidden="true"
            />
            <span>{t(`status.${status}` as MessageKey)}</span>
            <span className="legend__count num">{counts.get(status) ?? 0}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
